import { EditClient, AddUsers, CSV_FILE_SIZE_LIMIT, DataFromUrl, REDIRECT, SUCCESS_REPONSE_CODE, toastr, 
         UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode, CustomToastrAction} 
         from '@/imports-files/pages/admins/dashboard/clients/add-users';


export async function handleOnSubmit(values, router, queryClient, setApiError)
{
  // const path          =   window.location.pathname.split('/').slice(-2)[0];
  const path                 =   new DataFromUrl().getClientId();
  const result               =   await new AddUsers().createNewClientUser(values, path);
  setApiError(result.request);
  const status_code          =   result.status || result.response.status;
  const customToastrAction   =   new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      const response = result.data;
      if (response.success) 
      {
        // router.push(REDIRECT.admins.dashboard.clients.integration.replace('$client_id', response.id))
        let link  = REDIRECT.admins.dashboard.clients.integration.replace('$client_id', response.slug);
        router.push(link);
        // goToNextPage('integrations', setPageName, queryClient, link);
        await queryClient.removeQueries('add-user-data');
      }
      break;
    case UNAUTHORIZED_REPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      // toastr.warning(result.response.data.error);
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      if(result.response.data.error.client?.base){
        customToastrAction.setNormalToastr(result.response.data.error.client?.base, 'warning');
        // toastr.warning(result.response.data.error.client?.base);
      }
      return result.response.data.error
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }

}

export async function onAdminUserAdd(...args) 
{
  // ---------------------------- Initialization ------------------------------
  const formik                    =   args[0]?.current;
  const action                    =   args[1];
  const setAdminCount             =   args[2];
  const queryClient               =   args[3];
  const client_users_attributes   =   formik.values.client.client_users_attributes;
  const client                    =   formik.values.client
  // ---------------------------- Initialization ------------------------------

    client_users_attributes.push({
                                    role_id: "",
                                    status_id: "",
                                    _destroy: false,
                                    deletable: true,
                                    user_attributes:{
                                                      name: '',
                                                      email: ''
                                                    }
                                })

  // formik.current.setValues({client, client_users_attributes});
  formik.setValues({client, client_users_attributes});
  var records_length = client_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
  await queryClient.setQueryData('add-user-data', client_users_attributes);
  setAdminCount(records_length);
}

export async function onAdminUserRemove(...args) 
{
  // ---------------------------- Initialization ------------------------------
  const formik                    =   args[0];
  const action                    =   args[1];
  const setAdminCount             =   args[2];
  const index                     =   args[3]!=undefined ? args[3] : '';
  const queryClient               =   args[4];
  const client_users_attributes   =   formik.values.client.client_users_attributes;
  const client                    =   formik.values.client
  // ---------------------------- Initialization ------------------------------
  
  client_users_attributes[index]['_destroy'] = true;

  // formik.current.setValues({client, client_users_attributes});
  formik.setValues({client, client_users_attributes});
  var records_length = client_users_attributes.map((element) => element._destroy == false).filter((element) => element==true).length
  await queryClient.setQueryData('add-user-data', client_users_attributes);
  setAdminCount(records_length);
}

export async function clientRoles(client_auth_cookies, setApiError) 
{
  const results = await new AddUsers().getClientUserRoles(client_auth_cookies);
  setApiError(result.request);
  const data = [];
  results?.data?.roles.map( (values, index)=>{
    data.push({value: values.id, label: values.display_name});
  });
  return data;
}

export async function roles(setApiError) 
{
  const results = await new AddUsers().getUserRoles();
  setApiError(results.request);
  const data = [];
  results?.data?.roles.map( (values, index)=>{
    data.push({value: values.id, label: values.display_name});
  });


  return data;
}

export async function handelFileChange(data, formik, setAdminCount, userRoles, queryClient, fileInfo)
{

  var fileSize = fileSizeValid(fileInfo);
  var csvValid = isCSVFileValid(data, userRoles);
  if(!(fileSize && csvValid) )
  {
    return false;
  }
  else
  {
    // TODO : - set the errors in the formik schema
        const client_users_attributes = formik.current.values.client.client_users_attributes;
        const client                  = formik.current.values.client
    // ---------------------------- Initialization ------------------------------

    data.length > 0 ? remove_blank_formik_fields(formik, client, client_users_attributes, setAdminCount) : '';

    for( var user of data)
    {
      var role_id = userRoles.findIndex(obj => obj.label === user.role)
      client_users_attributes.push({
                                      role_id: userRoles[role_id].value,
                                      _destroy: false,
                                      deletable: true,
                                      user_attributes:{
                                                        name: user.name,
                                                        email: user.email
                                                      }
                                  })
    }

    formik.current.setTouched({client, client_users_attributes});
    setAdminCount(client_users_attributes.length);
    await queryClient.setQueryData('add-user-data', client_users_attributes);
    document.getElementById('react-csv-reader-input').value = null;
  }
}

// INFO:- This function will removes the blank fields which are not filled yet
export function remove_blank_formik_fields(formik, client, client_users_attributes, setAdminCount)
{

  for (var index = client_users_attributes.length-1 ; index >= 0; index--)
  {
      if( client_users_attributes[index].role_id == "" &&
          client_users_attributes[index].user_attributes.name =="" &&
          client_users_attributes[index].user_attributes.email =="" )
      {
          client_users_attributes.splice(index, 1);
      }
      else
      {
        break;
      }
  }

  // set the formik schema and re render it by changing the state
  formik.current.setValues({client, client_users_attributes});
  setAdminCount(client_users_attributes.length);

}



export async function getClientData(setApiError)
{
    // const client_id    =   window.location.pathname.split('/').slice(-2)[0];
    const client_id    =   new DataFromUrl().getClientId();
    const result       =   await new EditClient().getClientInfo(client_id);
    setApiError(result.request);
    
    const client       =   result.data.client
    const data         =   {
                              clientData:{
                                            userRoles: await roles(setApiError),
                                            client: client
                                         }
                           }
    // account owner remove from userlist                       
    let role_ids = data.clientData.userRoles.map((x) => x.value)
    data.clientData.client.client_users_attributes = data.clientData.client.client_users_attributes.filter((x) => {
      if(role_ids.includes(x.role_id))
      return x
    });    

    return data;
}


function fileSizeValid(fileInfo)
{
    if(fileInfo.size > CSV_FILE_SIZE_LIMIT)
    {
      new CustomToastrAction().setNormalToastr('The file size is greater than 1MB', 'success'); 
      // toastr.success('The file size is greater than 1MB');
      document.getElementById('react-csv-reader-input').value = null
      return false;
    }
    else
    {
      return true;
    }
}

function isCSVFileValid(data, userRoles)
{
  try
  {
    for( var user of data)
    { 
      var role_id = userRoles.findIndex(obj => obj.label === user.role)
      userRoles[role_id].value;
      user.name;
      user.email;
    }

    return true;
  }
  catch(exception)
  {
      // toastr.success('Invalid File');
      new CustomToastrAction().setNormalToastr('Invalid File', 'success'); 
      document.getElementById('react-csv-reader-input').value = null;
      return false;
  }
}